import React, { useEffect, useState } from "react";
import { Outlet, useMatch, useNavigate, useParams } from "react-router";
import { connect } from "react-redux";
import HeaderPage from "../../components/header/header";
import SportsHeader from "../../components/SportsHeader/sports-header";
import { RootState } from "../../models/RootState";
import { Provider } from "../../models/provider";
import API from "../../services/index";
import { setProviderId } from "../../store";
import "./LobbyView.scss";
import {
  isConnected,
  disconnectToWS,
  connectToWS,
  isDreamWsConnected,
  connectToDreamWS,
} from "../../websockets/websocket";
import {
  DefaultRedirectTosportByPartner,
  ProviderSortOrderByPartner,
} from "../../constants/common-utlits";
import { TopicUrls } from "../../models/sportsBookState";

type storeProps = {
  operatorId: string;
  setProviderId: Function;
  loading: boolean;
  topicUrls: TopicUrls;
};

const LobbyView: React.FC<storeProps> = (props) => {
  const { operatorId, setProviderId, loading, topicUrls } = props;
  const [providers, setProviders] = useState<Provider[]>();
  let navigate = useNavigate();
  let { provider } = useParams();
  const providerId = sessionStorage.getItem("psOperatorId");
  const path = useMatch("");

  useEffect(() => {
    sessionStorage.setItem("psProviderId", provider);
  }, [provider]);

  useEffect(() => {
    getProviders();
  }, []);

  const getProviders = async () => {
    try {
      const response: any = await API.post("/getproviders", {
        operatorId: sessionStorage.getItem("psOperatorId"),
      });

      if (response.data.status === "RS_OK") {
        // Sort by aplhb order
        let providersList = ProviderSortOrderByPartner(
          sessionStorage.getItem("psOperatorId"),
          response.data.providers
        );
        setProviders(providersList);

        if (response?.data?.providers && providersList.length > 0) {
          connectWebsocket();

          provider
            ? sessionStorage.setItem("psProviderId", provider)
            : sessionStorage.setItem(
              "psProviderId",
              providersList[0]?.providerId
            );
          await setProviderId(sessionStorage.getItem("psProviderId"));

          sessionStorage.getItem("currentRoute")
            ? sessionStorage.getItem("currentRoute")
            : providersList[0].providerId !== "SportRadar"

              ? navigate(`/lobby/${sessionStorage.getItem("psProviderId")}/inplay`)
              : navigate(DefaultRedirectTosportByPartner());
        } else {
          navigate("/no-access");
        }
      } else {
        navigate("/no-access");
      }
    } catch (err) {
      navigate("/no-access");
    }
  };

  const connectWebsocket = () => { };

  useEffect(() => {
    if (providers && providers.length > 0) {
      if (isConnected() || isDreamWsConnected()) {
        disconnectToWS();
      }
      const baseUrlsPayload = {
        prBaseUrl: topicUrls?.prBaseUrl
      }
      connectToWS(baseUrlsPayload);
      connectToDreamWS();
    }

    return () => {
      if (isConnected()) {
        disconnectToWS();
      }

      if (isDreamWsConnected) {
        disconnectToWS();
      }
    };
  }, [providers]);

  return (
    <>
      <HeaderPage providers={providers} />
      {providers && providers.length > 0 ? (
        <SportsHeader provider={providers[0]} />
      ) : null}
      {/* {loading ? <FullPageLoader /> : null} */}
      <div className={operatorId !== "MPC1" ? "mt-100" : "mt-50"}>
        <Outlet />
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    loading: state.auth.loading,
    premiumEventInfo: state.sportsBook.premiumEventInfo,
    topicUrls: state?.sportsBook?.topicUrls
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    setProviderId: (pid: string) => dispatch(setProviderId(pid)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LobbyView);
